export default function Wall(p5, bottom, inputWall) {
  const h = 20;
  const w = 120;
  const b = bottom;
  const wall = inputWall;

  this.hover = null;
  this.x = wall.x;
  this.y = b - h - wall.y * h;
  this.color = "transparent";

  this.wall = inputWall;

  this.render = () => {
    this.y = b - h - wall.y * h;
    this.x = wall.x;
    p5.push();
    p5.fill(this.color);
    p5.rect(wall.x, b - h - wall.y * h, w / 2, h);
    p5.rect(wall.x + w / 2, b - h - wall.y * h, w / 2, h);
    p5.rectMode(p5.CENTER);
    p5.pop();

    p5.push();
    p5.rectMode(p5.CENTER);
    if (wall.windows === 1 && wall.frenchDoor) {
      p5.rect(wall.x + w / 1.5, b - h - wall.y * h + h / 2, h / 2, h / 2);
      p5.fill(0);
      p5.textAlign(p5.CENTER, p5.CENTER);
      p5.text(`FD`, wall.x + w / 1.2, b - wall.y * h - h / 2);
    } else if (wall.doors && wall.windows === 1) {
      p5.rect(wall.x + w / 1.67, b - h - wall.y * h + h / 2, h / 2, h / 2);
      p5.fill(0);
      p5.textAlign(p5.CENTER, p5.CENTER);
      p5.text(`DOOR`, wall.x + w / 1.23, b - wall.y * h - h / 2);
    } else if (wall.windows === 1) {
      p5.rect(wall.x + w / 1.33, b - h - wall.y * h + h / 2, h / 2, h / 2);
    } else if (wall.windows === 2) {
      p5.rect(wall.x + w / 1.2, b - h - wall.y * h + h / 2, h / 2, h / 2);
      p5.rect(wall.x + w / 1.5, b - h - wall.y * h + h / 2, h / 2, h / 2);
    } else if (wall.frenchDoor) {
      p5.fill(0);
      p5.textAlign(p5.CENTER, p5.CENTER);
      p5.text(`FD`, wall.x + w / 1.33, b - wall.y * h - h / 2);
    } else if (wall.doors) {
      p5.fill(0);
      p5.textAlign(p5.CENTER, p5.CENTER);
      p5.text(`DOOR`, wall.x + w / 1.33, b - wall.y * h - h / 2);
    }
    p5.pop();
    p5.push();
    p5.fill(0);
    p5.textAlign(p5.CENTER, p5.CENTER);
    p5.text(`${wall.id + 1}`, wall.x + w / 8, b - wall.y * h - h / 2);
    p5.pop();
  };
}
